module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper"
  }, [(_vm.device === 'mobile' && _vm.sidebar.opened) ? _c('div', {
    staticClass: "drawer-bg",
    on: {
      "click": _vm.handleClickOutside
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.seeNavbarSidebar) ? _c('sidebar', {
    staticClass: "sidebar-container"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [(!_vm.seeNavbarSidebar) ? _c('navbar') : _vm._e(), _vm._v(" "), _c('app-main')], 1), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6818c448!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Layout.vue
// module id = 600
// module chunks = 2